// Module
var code = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.197 14.17v1.23a.6.6 0 0 0 .983.461l3.598-2.998a.6.6 0 0 0 0-.924L12.18 8.94a.6.6 0 0 0-.983.462v1.17a6.261 6.261 0 0 1-5.272-4.085L5.164 4.4a.6.6 0 0 0-.564-.395.282.282 0 0 0-.102 0 .6.6 0 0 0-.498.6v1.799a7.796 7.796 0 0 0 7.197 7.766z\"/></svg>";
// Exports
module.exports = code;